// generic button with loading animation

import useLanguage from '@/utils/hooks/useLanguage';
import cn from 'classnames';
import { ComponentProps, ReactNode } from 'react';
import Loader from './Loader';

interface IButton extends ComponentProps<'button'> {
    onClick?(e): void;
    isLoading?: boolean;
    children: ReactNode;
    className?: string;
    loader?: ReactNode;
}

export const Button = (props: IButton) => {
    const { isLoading, children, loader, className, disabled, ...restProps } = props;

    const lang = useLanguage();

    return (
        <button
            type="submit"
            {...restProps}
            className={cn(
                'w-full flex items-center justify-center gap-3 text-sm py-2 px-4 rounded-md',
                'shadow-sm font-medium focus:outline-none focus:ring-2 focus:ring-brand-accent-light',
                {
                    'bg-brand-accent text-brand-module-title hover:bg-brand-accent-light bg-brand-gradient hover:bg-brand-gradient-hover cursor-pointer':
                        !disabled
                },
                {
                    'bg-brand-neutral-700 hover:bg-brand-neutral-600 focus:ring-neutral-600 cursor-not-allowed text-brand-neutral-400':
                        disabled
                },
                className
            )}
            disabled={isLoading || disabled}>
            {isLoading && (
                <>
                    {loader ? loader : <Loader className="ml-0 mr-0" />}
                    {lang.common.loading}...
                </>
            )}
            {!isLoading && children}
        </button>
    );
};
